'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';
import ServiceDetailsImg from '../../assets/images/services/MAGNET.png'
import ServiceDetailsImg1 from '../../assets/images/services/fixboom (1).png'
import ServiceDetailsImg2 from '../../assets/images/services/service-details-images-1-2.jpg'
import ImageGallery from "react-image-gallery";
import 'react-image-gallery/styles/css/image-gallery.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import table, { Table } from 'react-bootstrap'
import SEOHelmet from '../../components/SEO/SEOHelmet';
// import ModalVideo from 'react-modal-video';
// import 'react-modal-video/css/modal-video.min.css';
const mainSlider = {
    width: '90%',
}
const FixedBoomExcavator = () => {
    const images = [
        {
            original: ServiceDetailsImg1,
            thumbnail: ServiceDetailsImg1,
            originalAlt: "Slide 1",
            thumbnailAlt: "Thumbnail 1",
        },
        // { 410X361px
        //     original: ServiceDetailsImg2,
        //     thumbnail: ServiceDetailsImg2,
        //     originalAlt: "Slide 2",
        //     thumbnailAlt: "Thumbnail 2",
        // }

    ]
    // State to hold dynamic content
    const [projectInfo] = useState({
        category: "Roof Service",
        customer: "David Bravis",
        startDate: "21 April 2024",
        endDate: "28 September 2024",
        rating: 5,
    });
    const [socialLinks] = useState([
        { href: "#", iconClass: "icon-linkedin-in" },
        { href: "#", iconClass: "icon-facebook-f" },
        { href: "#", iconClass: "icon-instagram" },
        { href: "#", iconClass: "icon-Vector" },
    ]);
    const [serviceDetails] = useState({


        image1: ServiceDetailsImg,

        title: "Fixed Boom Excavator",
        text2: "This type of fixed boom excavator is frequently used to feed scrap shear machines beneath the cover shed. When compared to covered shed E.O.T cranes, it can also feed more scrap to the machine.It can rotate 360 degrees clockwise at the same time and is a low-maintenance machine that is often used in steel factories to feed scrap shear machines of various sorts. Nowadays, these machines have been utilized to increase the amount of scrap fed to shear machines in a shorter duration.",

    });

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Fixed Boom Excavator for Scrap Processing"
                description="Efficient fixed boom excavator for feeding scrap to shear machines. 360-degree rotation, low-maintenance, and widely used in steel factories worldwide."
                keywords="fixed boom excavator, excavator, scrap feeder, boom excavator, material handling"
                canonicalUrl="https://ramanasteels.com/fixed-boom-excavator"
            />
            {/* Service Details Start */}
            <section className="service-details">
                <div className="container">
                    <div className="row">
                        <div className="col-xl-8 col-lg-7">
                            <div className="service-details__left">
                                <div className="service-details__content-one">

                                    <p className="service-details__text-1">{serviceDetails.text1}</p>
                                    <div className="justify-content-center mt-4">
                                        <div className="card p-3 rounded" style={mainSlider}>
                                            <ImageGallery
                                                items={images}
                                                showPlayButton={false}
                                                showFullscreenButton={true}
                                                showThumbnails={true}
                                                autoPlay={true}
                                                slideInterval={4000}
                                                showNav={true}
                                                additionalClass="img-slider"
                                            />
                                        </div>
                                    </div>
                                    <h3 className="service-details__title-one">{serviceDetails.title}</h3>
                                </div>
                                <div className="service-details__content-two">
                                    <h4 className="service-details__title-two">{serviceDetails.title2}</h4>
                                    <p className="service-details__text-2">{serviceDetails.text2}</p>

                                </div>
                                <div>
                                    <Table responsive>
                                        <thead style={{ color: '#FFFFFF', background: '#2F8CD6', maxWidth: '100%' }}><tr> <th>MOVABLE ARM  </th>
                                            <th>EFFECTIVE GRAPPLE SCOPE </th>
                                            <th>WORKING PRESSURE</th>
                                            <th>MOTOR </th>
                                            <th>PUMP</th>
                                            <th>ROTATING SPEED</th>
                                            <th>BUCKET ARM</th>
                                        </tr></thead>
                                        <tbody>
                                            <tr>
                                                <td>5000mm</td>
                                                <td>8900mm</td>
                                                <td>21.5Mpa</td>
                                                <td>37KW</td>
                                                <td>A7V160</td>
                                                <td>4-6 times/ min</td>
                                                <td>3900mm</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-5">
                            <div className="project-details__sidebar">
                                <div className="project-details__project-info">
                                    <h3 className="project-details__project-info-title">
                                        Product Information
                                    </h3>
                                    <ul className="list-unstyled project-details__project-info-list">
                                        <li>
                                            <h5>Origin:</h5>
                                            <h5>China{/* {projectInfo.category} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Make:</h5>
                                            <h5>Gaode{/* {projectInfo.customer} */}</h5>
                                        </li>
                                        <li>
                                            <h5>Used In:</h5>
                                            <h5> Heavy duty scrap<br /> processing{/* {projectInfo.startDate} */}</h5>
                                        </li>
                                        {/* <li>
                                            <h5>End date:</h5>
                                            <h5>{projectInfo.endDate}</h5>
                                        </li> */}
                                        <li>
                                            <h5>Rating:</h5>
                                            <div className="rating">
                                                {Array(projectInfo.rating)
                                                    .fill(0)
                                                    .map((_, index) => (
                                                        <span className="icon-star" key={index}></span>
                                                    ))}
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="project-details__social">
                                        {socialLinks.map((link, index) => (
                                            <Link to={link.href} key={index}>
                                                <span className={link.iconClass}></span>
                                            </Link>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="project-details__need-help">
                                {/* <div className="project-details__need-help-img">
                                    <img
                                        src="/assets/images/project/project-details-need-help-img.jpg"
                                        alt="Need Help"
                                    />
                                </div> */}
                                <div className="project-details__need-help-icon">
                                    <span className="icon-call"></span>
                                </div>
                                <p className="project-details__need-help-sub-title">
                                    Contact Us
                                </p>
                                <h3 className="project-details__need-help-number">
                                    <Link to="tel:+91-9815902561"> +91-9815902561</Link>
                                </h3>
                            </div>
                            {/* <div className="project-details__download">
                                <ul className="project-details__download-list list-unstyled">
                                    <li>
                                        <Link to="#">
                                            <span>Company File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#">
                                            <span>Project File</span>
                                            <p>
                                                (1.5Mb)
                                                <i className="icon-download"></i>
                                            </p>
                                        </Link>
                                    </li>
                                </ul>
                            </div> */}
                        </div>

                    </div>
                </div>
            </section>
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default FixedBoomExcavator;


